import React from "react";
import moment from "moment";
import { Alert } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import MaxMDLabel from "./components/MaxMDLabel";

/**
 * @date: 12/8/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
export function validateFqdn(domain){
    const pattern = /^(?=.{1,254}$)((?=[a-z0-9-]{1,63}\.)(xn--+)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}$/i;
    return pattern.test(domain);
}
export function validateEmail(domain){
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(domain);
}
export function validateNpi(domain){
    const pattern = /^[0-9]{10}$/i;
    return pattern.test(domain);
}
export function validateDuns(domain){
    const pattern = /^[0-9]{9}$/i;
    return pattern.test(domain);
}
export function validateTaxId(domain){
    const pattern = /^[0-9]{9}$/i;
    return pattern.test(domain);
}
export function validateZip5(domain){
    const pattern = /^[0-9]{5}$/i;
    return pattern.test(domain);
}

export const PEM_CSR_BEGIN = "-----BEGIN CERTIFICATE REQUEST-----";
export const PEM_CSR_END = "-----END CERTIFICATE REQUEST-----";
export const CSR_MODE_AUTO = 'auto';
export const CSR_MODE_UPLOAD = 'upload';


export function getDateFromString(s){
    const time = Date.parse(s);
    return new Date(time);
}
export function getCurrentDateString() {
    return convertDateToString(new Date());
}
export function convertDateToString(date){
    return moment(date).format("YYYY-MM-DD");
}
export function formatDateString(s){
    const date = getDateFromString(s);
    return moment(date).format("YYYY-MM-DD");
}
export function convertDateToTimeString(date){
    return moment.utc(date).format("YYYY-MM-DD HH:mm:ss");
}
export function printDateHtml(v){
    if (v == null){
        return "";
    }
    let date;
    if (v instanceof Date){
        date = v;
    } else if (!isNaN(v)){
        // timestamp in MS
        date = new Date(v);
    } else {
        // date string
        const time = Date.parse(v);
        date = new Date(time);
    }
    return <span title={date.toString()}>{convertDateToString(date)}</span>
}
export function printTimeHtml(v){
    if (v == null){
        return "";
    }
    let date;
    if (v instanceof Date){
        date = v;
    } else if (!isNaN(v)){
        // timestamp in MS
        date = new Date(v);
    } else {
        // date string
        const time = Date.parse(v);
        date = new Date(time);
    }
    return <span title={date.toString()}>{convertDateToTimeString(date)}</span>
}

export function printTime(v){
    if (v == null){
        return "";
    }
    let date;
    if (v instanceof Date){
        date = v;
    } else if (!isNaN(v)){
        // timestamp in MS
        date = new Date(v);
    } else {
        // date string
        const time = Date.parse(v);
        date = new Date(time);
    }
    return convertDateToTimeString(date);
}

export function getDaysToExpire(expDate){
    if (expDate == null){
        return false;
    }
    return Math.round((expDate.getTime() - new Date().getTime()) / 86400000);
}

export function printStatusHtml(status, revokeReason, labelPrefix){
    if (!status){
        return "";
    }
    const upper = status.toUpperCase();
    const label = `${labelPrefix}${upper}`;
    if (upper === "VALID"){
        return <MaxMDLabel color='success' renderHtml={() => <>{label}</>} />
    } else if (upper === "APPROVED"){
        return <MaxMDLabel color='info' value={label}/>
    } else if (upper === "PENDING"){
        return <MaxMDLabel value={label}/>
        // return <span> {label} </span>
    } else if (upper === "REVOKED"){
        return <>
            <MaxMDLabel color='error' value={label} />
            {revokeReason && <Alert color='error' icon={false}>Reason: {revokeReason} </Alert>}
        </>
    } else if (upper === "REKEYED"){
        return <MaxMDLabel color='info' value={label}/>
    }
    // if (upper === "VALID"){
    //     return <Alert color='success' icon={false}>  {upper} </Alert>
    // } else if (upper === "APPROVED"){
    //     return <Alert color='info' icon={false}> {upper} </Alert>
    // } else if (upper === "PENDING"){
    //     return <span> {upper} </span>
    // } else if (upper === "REVOKED"){
    //     return <Alert color='error' icon={false}>
    //         {upper}
    //         {revokeReason && <><br/>Reason: {revokeReason} </>}
    //     </Alert>
    // } else if (upper === "REKEYED"){
    //     return <Alert color='info' icon={false}>  {upper} </Alert>
    // }
}

export function insertColonToHexString(s){
    if (!s){
        return "";
    }
    var out = "", index = 0;
    if (s.length %2 === 1){
        out += "0" + s.substr(0, 1);
        index++;
    } else {
        out += s.substr(0, 2);
        index += 2;
    }
    while (index < s.length){
        out += ":" + s.substr(index, 2);
        index += 2;
    }
    return out;
}
